<template>
  <li class="timeline-item">
    <div class="timeline-badge" :class="item.icon_status">
      <i class="icon" :class="item.icon_class"></i>
    </div>
    <div class="timeline-panel">
      <div class="timeline-heading">
        <h4 class="timeline-title">{{ item.title }}</h4>
        <div class="timeline-panel-controls">
          <div class="controls">
            <time-line-control v-for="control in item.controls" :key="control" :control="control"/>
          </div>
          <div class="timestamp">
            <small class="text-muted">
              {{ item.updated | moment('D/MM/Y HH:mm') }} ({{ item.updated | moment('from', 'now') }})
            </small>
          </div>
        </div>
      </div>

      <div class="l-row code-container" v-if="item.dataJSON">
        <div class="l-col-10@md data-json">
          <vue-json-pretty :data="item.dataJSON" :deep="3"/>
        </div>

        <div class="l-col-2@md u-textRight">
          <button type="button" class="btn btn--success" v-clipboard:copy="JSON.stringify(item.dataJSON)">
            <i class="icon icon-copy2"></i>
          </button>
        </div>
      </div>

      <div class="timeline-body" v-html="item.body"></div>
    </div>
  </li>
</template>

<script>
  import TimeLineControl from '@/components/template/timeLine/Control'
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    methods: {
      delete: function () {
        this.$dispatch('timeline-delete-item', this.item.id)
      },

      edit: function () {

      }
    },
    events: {
      'timeline-delete': function () {
        this.delete()
      },
      'timeline-edit': function () {
        this.edit()
      }
    },
    components: {
      TimeLineControl,
      VueJsonPretty
    }
  }
</script>

<style lang="sass" scoped>
  .timeline-item
    margin-bottom: 20px
    position: relative

    &:before,
    &:after
      content: " "
      display: table

    &:after
      clear: both

    .timeline-panel
      border-radius: 2px
      border: 1px solid #d4d4d4
      box-shadow: 0 1px 2px rgba(100, 100, 100, 0.2)
      margin-left: 100px
      padding: 20px
      position: relative
      background: #fff

      .timeline-heading
        .timeline-panel-controls
          position: absolute
          right: 8px
          top: 5px

          .timestamp
            display: inline-block

          .controls
            display: inline-block
            padding-right: 5px
            border-right: 1px solid #aaa

            a
              color: #999
              font-size: 11px
              padding: 0 5px

              &:hover
                color: #333
                text-decoration: none
                cursor: pointer

          .controls + .timestamp
            padding-left: 5px

  .timeline-badge
    background-color: #EEE
    border-radius: 50%
    font-size: 1.4em
    height: 50px
    left: 50px
    line-height: 52px
    margin-left: -25px
    position: absolute
    text-align: center
    top: 16px
    width: 50px
    z-index: 100

    .icon
      top: -4px
      font-size: 22px

  .timeline-badge + .timeline-panel
    &:before
      border-bottom: 15px solid transparent
      border-left: 0 solid #ccc
      border-right: 15px solid #ccc
      border-top: 15px solid transparent
      content: " "
      display: inline-block
      position: absolute
      left: -15px
      right: auto
      top: 26px

    &:after
      border-bottom: 14px solid transparent
      border-left: 0 solid #fff
      border-right: 14px solid #fff
      border-top: 14px solid transparent
      content: " "
      display: inline-block
      position: absolute
      left: -14px
      right: auto
      top: 27px

  .timeline-title
    margin-top: 0
    color: inherit

  .timeline-body
    & > p,
    & > ul
      margin-bottom: 0

    & > p + p
      margin-top: 5px

  .code-container
    padding: 10px 0
    background: #f5f7fa
    color: #69707a
    font-size: 12px
    overflow-x: scroll

</style>



// WEBPACK FOOTER //
// Item.vue?12da0f04